<template>
  <div>
    <table class="table table-bordered table-hover">
      <thead>
      <tr>
        <th style="width: 50%">Fields in current referral form</th>
        <th>Fields in Profile Form</th>
      </tr>
      </thead>
      <tbody>

      <tr>
        <td colspan="3">Required fields</td>
      </tr>
      <tr v-for="(field, idx) in requiredProfileFields">
        <td>
          <select class="form-control" v-model="requiredFieldsMap[field.value]" :class="{'error' : !requiredFieldsMap[field.value], 'warning' : duplicates.includes(requiredFieldsMap[field.value])}">
            <option :value="null">* Select field..</option>
            <option v-for="(option, oi) in formFields" :value="option.name" :disabled="['text-entry','header','row','divider'].includes(option.type)">{{option.description | striphtml }}</option>
          </select>
          <label v-if="!requiredFieldsMap[field.value]" class="error small">This field is required</label>
          <label v-if="duplicates.includes(requiredFieldsMap[field.value])" class="warning small">Warning: This field is selected more than once</label>
        </td>
        <td colspan="2">
          <select class="form-control" disabled="disabled">
            <option v-for="(option, oi) in profileFields" :value="oi" v-if="option.name == field.value">{{ option.description | striphtml }}</option>
          </select>
        </td>
      </tr>

      <tr>
        <td colspan="3">Optional fields</td>
      </tr>

      <tr v-for="(field, idx) in optionalFieldsMap">
        <td>
          <select class="form-control" v-model="field.referralField" :class="{'error' : !field.referralField, 'warning' : duplicates.includes(field.referralField)}">
            <option :value="null">Select field...</option>
            <option v-for="(option) in formFields" :value="option.name" :disabled="['text-entry','header','row','divider'].includes(option.type)">{{ option.description | striphtml }}</option>
          </select>
          <label v-if="!field.referralField" class="error small">Please select field</label>
          <label v-if="duplicates.includes(field.referralField)" class="warning small">Warning: This field is selected more than once</label>
        </td>
        <td style="padding-right: 25px; position: relative">
          <select class="form-control" v-model="field.profileField" :class="{'error' : !field.profileField}">
            <option :value="null"> Select field...</option>
            <option v-for="(option) in optionalProfileFields" v-if="optionalNotSelected(option.name, idx)" :disabled="['text-entry','header'].includes(option.type)" :value="option.name">{{ option.description | striphtml }}</option>
          </select>
          <label v-if="!field.profileField" class="error small">Please select field</label>
          <i class="remove-optional-field-btn fa fa-remove" @click="removeOptionalField(idx)"></i>
        </td>
      </tr>

      <tr>
        <td colspan="2">
          <button @click="addOptionalFieldMap" class="btn green">Add</button>
        </td>
      </tr>

      </tbody>
    </table>

  </div>
</template>

<script>
  import VueFormRender from '@/components/formbuilder/VueFormRender';
  import draggable from 'vuedraggable';
  import Collapse from '@/components/Collapse';
  import {mapGetters} from 'vuex';
  import vSelect from 'vue-select'
  import Spinner from "../../Spinner";

  export default {
    name: 'ReferralMapProfileForm',

    components: {
      draggable,
      VueFormRender,
      Collapse,
      'vue-spinner': Spinner,
      'vue-select': vSelect
    },
    props: {
      formFields: Array, // referral form fields
      fieldsMapFromServer: Array,
      requiredFieldsNames: {
        type: Array,
        default: () => ['first_name', 'last_name', 'name', 'date_birth']
      }
    },
    data() {
      return {
        profileFields: [],
        requiredProfileFields: [],
        requiredFieldsMap: {},
        optionalFieldsMap: [],
        fieldsMap: [],
        isValid: false,
        duplicates: []
      }
    },
    computed: {
      ...mapGetters({
        userAccounts: 'getUserAccounts',
        appUser: 'getUser',
        currentOrganization: 'getOrganization',
        systemForms: 'getSystemForms',
      }),
      optionalProfileFields() {
        return this.profileFields.filter(item => {
          return this.requiredProfileFields.find(requiredItem => requiredItem.value === item.name) === undefined;
        });
      },
      profileForm() {
        return this.systemForms.profile;
      }

    },

    watch: {
      optionalFieldsMap: {
        deep: true,
        handler() {
          this.updateFieldsMap();
        }
      },
      requiredFieldsMap: {
        deep: true,
        handler() {
          this.updateFieldsMap();
        }
      },
      formFields(newFields) { // watching items, but adding auto map
        newFields.forEach(field => {

          if (!field.hasOwnProperty('autoMap') || !field.autoMap) {
            return;
          }

          if (this.requiredProfileFields.find(requiredField => requiredField.value === field.profileFieldName) !== undefined) {
            if (!this.requiredFieldsMap.hasOwnProperty(field.profileFieldName)) {
              this.$set(this.requiredFieldsMap, field.profileFieldName, field.name);
            }
          } else {
            if (this.optionalFieldsMap.find(optionalField => optionalField.profileField === field.profileFieldName) === undefined) {
              this.optionalFieldsMap.push({
                'referralField': field.name,
                'profileField': field.profileFieldName
              });
            }
          }
        });

        this.$emit('fieldsMapUpdated', this.fieldsMap);
        this.$emit('profileMapValidStatusUpdated', this.validateProfileMap());
      }
    },
    beforeMount() {
      try {
        let profileFieldsMap = JSON.parse(this.profileForm.columns_map);
        this.requiredProfileFields = profileFieldsMap.filter(profileField => (this.requiredFieldsNames).includes(profileField.name));
      } catch (e) {
        this.requiredProfileFields = [];
      }

      try {

        let fields = JSON.parse(this.profileForm.data).filter(item => {
          return !(['row', 'divider', 'header'].includes(item.type));
        });

        let flatFields = [];

        fields.forEach(field => {
          flatFields.push(field);
          if(field.type === 'accordion') {
            field.values.forEach(fieldInAccordion => {
              flatFields.push(fieldInAccordion);
            })
          }
        });

        this.profileFields = flatFields;

      } catch (e) {
        this.profileFields = [];
      }

      this.fillMapFromServer();
    },

    methods: {
      addOptionalFieldMap() {
        this.optionalFieldsMap.push({
          'referralField': null,
          'profileField': null
        });
      },
      validateProfileMap() {
        let valid = true;

        this.requiredProfileFields.forEach(item => {
          let fieldInMap = this.fieldsMap.find(field => field.sourceValue === item.value);
          if (fieldInMap === undefined || !fieldInMap.value) {
            valid = false;
          }
        })

        return valid;
      },
      updateFieldsMap() {
        let flatMap = {...this.requiredFieldsMap}

        this.optionalFieldsMap.forEach(item => {
          if (item.referralField) {
            flatMap[item.profileField] = item.referralField;
          }
        });

        this.duplicates = [];

        let values = [];
        let newMap = [];

        Object.keys(flatMap).forEach(item => {
          if (values.includes(flatMap[item])) {
            this.duplicates.push(flatMap[item]);
          } else {
            values.push(flatMap[item]);
          }

          let name = item;
          let profileItem = this.requiredProfileFields.find(field => field.value === item);

          if (profileItem && profileItem.hasOwnProperty('name')) {
            name = profileItem.name;
          }

          newMap.push({
            'name': name,
            'sourceValue': item,
            'value': flatMap[item]
          })
        });

        this.fieldsMap = newMap;

        this.$emit('fieldsMapUpdated', newMap);
        this.$emit('profileMapValidStatusUpdated', this.validateProfileMap());

      },
      removeOptionalField(idx) {
        this.optionalFieldsMap.splice(idx, 1);
      },
      optionalNotSelected(field, idx) {
        let found = this.optionalFieldsMap.findIndex(item => item.profileField === field);
        return (found === idx) || (found === -1);
      },
      fillMapFromServer() {
        this.requiredProfileFields.forEach((requiredField, idx) => {
          if (!this.fieldsMapFromServer.length) {
            return;
          }

          let serverField = this.fieldsMapFromServer.find(field => field.sourceValue === requiredField.value);

          if (serverField !== undefined) {
            this.$set(this.requiredFieldsMap, serverField.sourceValue, serverField.value);
          }
        });

        this.optionalFieldsMap = [];

        this.fieldsMapFromServer.forEach((serverItem) => {
          if (this.requiredProfileFields.find(requiredField => requiredField.value === serverItem.sourceValue) === undefined) {
            this.optionalFieldsMap.push({
              'referralField': serverItem.value,
              'profileField': serverItem.sourceValue
            })
          }
        });

        this.updateFieldsMap()
      }
    }
  }

</script>

<style scoped lang="scss">
  .remove-optional-field-btn {
    position: absolute;
    top: 18px;
    right: 7px;
    cursor: pointer;
  }

  .warning {
    color: #d09f23;
  }

  .error {
    color: #f00;
  }

  select.warning {
    border: 1px #d09f23 solid;
  }

  select.error {
    border: 1px #f00 solid;
  }

</style>



// WEBPACK FOOTER //
// ReferralMapProfileForm.vue?6bb01f1d